module.exports = __webpack_public_path__ + "static/media/image-3.83d40b2f.jpg";